'use strict';
import Labels from "./labels";
import Config from "./config";

let utils = {
  eventQueue: [],
  retryCount: 0,
  timer: null,
  getIsoDate(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}`
  },
  twoDigits(x) {
    if (x < 10) return `0${x}`;
    else return `${x}`;
  },
  processFacetChecked(facets, opt) {
    if (!facets || !opt || !opt.sender) return;
    if (opt.checked && opt.sender.value) {
      facets.push(opt.sender.value);
    }
    else {
      var pos = facets.indexOf(opt.sender.value);
      if (pos != -1) facets.splice(pos, 1);
    }
    return facets;
  },
  showStatusMessage (msg, color, duration) {
    if (!msg) return;
    color = color || "green";
    duration = duration | 5000;
    let messageBox = document.createElement("div");
    messageBox.classList.add("cla-messagebox");
    messageBox.classList.add(color);
    messageBox.innerHTML = msg;
    document.body.appendChild(messageBox);
    setTimeout(() => {
      if (messageBox) {
        messageBox.style.opacity = '0';
        setTimeout(() => {
          messageBox.remove();
        }, 500);
      }
    }, duration);
  },
  showLoader (element, showAtTheTop) {
    let el = typeof(element) === "string" ? document.querySelector(element) : element;
    if (!el) {
      console.warn(`Could not create loader in the element ${typeof(element)==="string" ? element : element.name}`);
      return;
    }
    let loader = document.createElement("div");
    loader.classList.add("loader");
    if (showAtTheTop) loader.classList.add("top");
    el.appendChild(loader);
    return loader;
  },
  removeLoader (loader) {
    if (!loader) return;
    if (!loader.parentNode) return;
    loader.parentNode.removeChild(loader);
  },
  getCookie(name) {
      var regexp = new RegExp("(?:^" + name + "|;\s*"+ name + ")=(.*?)(?:;|$)", "g");
      var result = regexp.exec(document.cookie);
      return (result === null) ? "" : result[1];
  },
  reportToAnalytics(description, value) {
    //we need to check if the analytics object exists. If not, we cache the events and submit them when the object becomes available
    let target = this.eventQueue;
    if (typeof(dataLayer) !== "undefined") {
        console.log(`Submitting event ${description} to analytics`);
        target = dataLayer;
    }
    else if (this.timer == null) {
        console.log("Setting up analytics timer.")
        this.timer = setInterval(() => {
            console.log("Checking if analytics object is available.");
            if (typeof(dataLayer) !== "undefined") {
                console.log("Analytics object found. Submitting data.")
                clearInterval(this.timer);
                if (this.eventQueue.length > 0) {
                    dataLayer.splice(dataLayer.length, 0, this.eventQueue);
                    this.eventQueue = [];
                }
            }
            else {
                this.retryCount++;
                if (this.retryCount > 10) {
                    console.log("Giving up on pushing search data to analytics.")
                    clearInterval(this.timer);
                }
            }
        }, 3000);
    }
        
    target.push({
        'event': 'claEvent',
        'description': description,
        'category': 'Document Finder',
        'value': value
    });
  },
  shortIdToGuid(input) {
    if (!input || input.length !== 32) return;
    let output = `{${input.substring(0, 8)}-${input.substring(8, 12)}-${input.substring(12, 16)}-${input.substring(16, 20)}-${input.substring(20, 32)}}`;
    return output.toUpperCase();
  },
  makeSafe(src) {
    //we replace characters not safe for paths with spaces
    if (!src) return "";
    return src.replace(/[^a-z0-9]/gi, ' ').trim();
  },
  waitForObjects() {
    let args = [...arguments];
    if (args.length < 2) return Promise.resolve();
    if (this.checkObjects(args)) return Promise.resolve();
    
    return new Promise((resolve, reject) => {
      const maxRetries = args[0];
      let count = 0;
      let interval = setInterval( () => {
        if (this.checkObjects(args)) {
          clearInterval(interval);
          resolve();
        } else if (count >= maxRetries){
          clearInterval(interval);
          reject();
        } else {
          count++;
        }
      }, 1000);
    });
  },
  checkObjects(objs) {
    if (!objs || objs.length == 0) return true;
    let isOk = true;
    for (let i = 1; i < objs.length; i++) {
      if (!objs[i]) {
        isOk = false;
        break;
      }
    }
    return isOk;
  }
};

export default utils;